import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

function usePathnameTransition({ currentRoute, routes, routesLevel }) {
    const location = useLocation();
    const [previousRoute, setPreviousRoute] = useState('');
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    useEffect(() => {
        if (!isInitialLoad) {
            // Convert pathname back to route name for comparison
            const pathToRoute =
                Object.entries(routes).find(
                    ([, path]) => path === location.pathname,
                )?.[0] || 'login';

            setPreviousRoute(pathToRoute);
        } else {
            setIsInitialLoad(false);
        }
    }, [location.pathname, isInitialLoad, routes]);

    // Determine transition direction based on route hierarchy
    const getTransitionDirection = () => {
        if (isInitialLoad || !previousRoute) return null;

        const currentLevel = routesLevel[currentRoute] || 0;
        const previousLevel = routesLevel[previousRoute] || 0;

        if (currentLevel > previousLevel) {
            // Going to a deeper route -> slide right to left
            return 'right';
        } else if (currentLevel < previousLevel) {
            // Going to a shallower route -> slide left to right
            return 'left';
        }

        return null; // Same level or no transition needed
    };

    return { isInitialLoad, getTransitionDirection };
}

export { usePathnameTransition };
